import { Map } from 'immutable';

import * as t from '../../actions/dashboardActionType';

const initialState = Map({
  loadingBadges: false,
  badges: {
    maxBadges: 0,
    badges: [],
  },
});

const reducer = function badgesReducer(state = initialState, action) {
  switch (action.type) {
    case t.SET_BADGES:
      return state.set('badges', action.badges);

    case t.SET_IS_LOADING_BADGES:
      return state.set('loadingBadges', action.isLoadingBadges);

    default:
      return state;
  }
};

export default reducer;
